// extracted by mini-css-extract-plugin
export default {"Badge":"kcb3qSho","Content":"rmC65j6f"};